import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { fetcTerminalData } from "../Services/terminal";
import HomePageTempleteA from "./TerminalByIdPreviewA";
import HomePageTempleteB from "./TerminalByIdPreviewB";
import ShopingCart from "../assets/dummyimage.jpg";
import useZoomDisable from "../hook/useZoomDisable";
import { useIsNightTime } from "../hook/useIsNightTime";
import { useActiveAds } from "../hook/useActiveAds";
import { DEFAULT_ROTATE_ADS } from "../Constants/constant";

const TemplateC = ({ advertisements }) => {
  const activeAds = useActiveAds(advertisements);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const terminalOrientation = searchParams.get("orientation");
  const advanceRef = useRef(null);

  advanceRef.current = () =>
    setCurrentIndex((prev) => (prev + 1) % activeAds.length);

  const currentAd = activeAds?.[currentIndex];
  const isVideo = !!currentAd?.videoUrl;

  useEffect(() => {
    if (!activeAds?.length || isVideo) return;
    const timer = setTimeout(() => advanceRef.current(), DEFAULT_ROTATE_ADS);
    return () => clearTimeout(timer);
  }, [activeAds, currentIndex, isVideo]);

  const isPortrait = terminalOrientation === "vertical";
  const isSingleVideo = activeAds.length === 1 && !!activeAds[0].videoUrl;

  return (
    <div className={`relative min-h-screen bg-white rounded shadow-lg overflow-hidden`}>
      {isVideo ? (
        <video
          key={currentAd.videoUrl}
          src={currentAd.videoUrl}
          autoPlay
          muted
          playsInline
          loop={isSingleVideo}
          onEnded={() => advanceRef.current()}
          className="absolute inset-0 w-full h-full object-contain"
        />
      ) : (
        <div
          className="w-full min-h-screen bg-contain bg-center bg-no-repeat bg-fixed"
          style={{
            backgroundImage: `url(${currentAd?.imageUrl || ShopingCart})`,
          }}
        >
          {!activeAds?.length && (
            <div className="absolute inset-0 bg-black/50" />
          )}
        </div>
      )}
      <button
        onClick={() =>
          setCurrentIndex((prev) => (prev + 1) % activeAds.length)
        }
        className="
               hidden
               absolute
               2xl:bottom-44
               bottom-8
               right-8
               bg-black/50
               rounded-full
               p-3
               hover:bg-black/70
               transition
               shadow-md
               flex
               items-center
               justify-center
             "
        aria-label="Next"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="61"
          height="52"
        >
          {/* <path d="M0 0 C20.13 0 40.26 0 61 0 C61 17.16 61 34.32 61 52 C40.87 52 20.74 52 0 52 C0 34.84 0 17.68 0 0 Z " fill="#121419" transform="translate(0,0)"/> */}
          <path
            d="M0 0 C18.15 0 36.3 0 55 0 C55 3.63 55 7.26 55 11 C52.06255476 11.16768291 49.12505096 11.33418858 46.1875 11.5 C45.35412109 11.54769531 44.52074219 11.59539063 43.66210938 11.64453125 C42.85966797 11.68964844 42.05722656 11.73476562 41.23046875 11.78125 C40.12288208 11.8440918 40.12288208 11.8440918 38.99291992 11.90820312 C37.33009506 11.98479533 35.6645879 12 34 12 C30.88214887 12.64644661 30.88214887 12.64644661 30 15 C28.906875 14.95875 27.81375 14.9175 26.6875 14.875 C22.00718143 15.03365487 20.09990173 16.7524839 17 20 C18.73636719 19.84337891 18.73636719 19.84337891 20.5078125 19.68359375 C32.48681643 18.91772301 32.48681643 18.91772301 36.359375 21.6875 C39.30830384 26.06529127 40.80725065 31.01158607 42.27734375 36.046875 C43.25940735 38.70110096 44.80593342 40.25987823 47 42 C44.03824877 41.38722388 42.61941217 40.74627478 40 39 C39.15625 37.046875 39.15625 37.046875 38.5 34.75 C37.32675076 30.94154696 35.99677353 27.47264961 34 24 C33.34 23.67 32.68 23.34 32 23 C32 23.66 32 24.32 32 25 C31.01 24.67 30.02 24.34 29 24 C29 23.34 29 22.68 29 22 C27.68 22 26.36 22 25 22 C24.67 23.32 24.34 24.64 24 26 C23.34 25.01 22.68 24.02 22 23 C21.01 22.67 20.02 22.34 19 22 C19.33 23.98 19.66 25.96 20 28 C19.34 28 18.68 28 18 28 C17.45730469 27.00097656 16.91460938 26.00195312 16.35546875 24.97265625 C15.63329987 23.66900073 14.91061681 22.36562995 14.1875 21.0625 C13.65286133 20.0734668 13.65286133 20.0734668 13.10742188 19.06445312 C10.97324509 15.00958993 10.97324509 15.00958993 7 13 C9.49100466 19.32268291 12.8746419 24.72441936 16.59179688 30.390625 C17.02943359 31.07125 17.46707031 31.751875 17.91796875 32.453125 C18.31781982 33.06317383 18.7176709 33.67322266 19.12963867 34.30175781 C20 36 20 36 20 39 C19.0925 38.690625 18.185 38.38125 17.25 38.0625 C14.83436662 37.2727737 12.47219715 36.57050703 10 36 C16.49545192 43.62509573 25.54373439 46.03194472 35 48 C35 48.66 35 49.32 35 50 C32.65532114 49.70691514 30.33274341 49.37091514 28 49 C26.205625 48.7215625 26.205625 48.7215625 24.375 48.4375 C18.00224999 46.83801531 12.4396554 42.56562778 7 39 C7.33 37.35 7.66 35.7 8 34 C10.31 34 12.62 34 15 34 C11.535 28.06 11.535 28.06 8 22 C4.04 22.495 4.04 22.495 0 23 C0 15.41 0 7.82 0 0 Z "
            fill="#181A20"
            transform="translate(0,0)"
          />
          <path
            d="M0 0 C1.98 0 3.96 0 6 0 C6 17.16 6 34.32 6 52 C2.37 52 -1.26 52 -5 52 C-5 51.67 -5 51.34 -5 51 C-3.35 51 -1.7 51 0 51 C0 40.44 0 29.88 0 19 C-0.66 18.67 -1.32 18.34 -2 18 C-1.34 18 -0.68 18 0 18 C0 12.06 0 6.12 0 0 Z "
            fill="#060607"
            transform="translate(55,0)"
          />
          <path
            d="M0 0 C2.52399159 0.95853879 3.3012567 1.99449683 4.796875 4.21484375 C5.22484375 4.83230469 5.6528125 5.44976563 6.09375 6.0859375 C7.046875 7.77734375 7.046875 7.77734375 7.046875 9.77734375 C7.975 9.61234375 8.903125 9.44734375 9.859375 9.27734375 C11.25409286 9.10158662 12.65014061 8.93628249 14.046875 8.77734375 C14.93890625 8.65101562 15.8309375 8.5246875 16.75 8.39453125 C19.73569773 8.14164428 22.12244984 8.10247641 25.046875 8.77734375 C29.81253807 12.94609548 31.59913419 18.9155459 33.32421875 24.82421875 C34.30628235 27.47844471 35.85280842 29.03722198 38.046875 30.77734375 C35.08512377 30.16456763 33.66628717 29.52361853 31.046875 27.77734375 C30.203125 25.82421875 30.203125 25.82421875 29.546875 23.52734375 C28.37362576 19.71889071 27.04364853 16.24999336 25.046875 12.77734375 C24.386875 12.44734375 23.726875 12.11734375 23.046875 11.77734375 C23.046875 12.43734375 23.046875 13.09734375 23.046875 13.77734375 C22.056875 13.44734375 21.066875 13.11734375 20.046875 12.77734375 C20.046875 12.11734375 20.046875 11.45734375 20.046875 10.77734375 C18.726875 10.77734375 17.406875 10.77734375 16.046875 10.77734375 C15.716875 12.09734375 15.386875 13.41734375 15.046875 14.77734375 C14.386875 13.78734375 13.726875 12.79734375 13.046875 11.77734375 C12.056875 11.44734375 11.066875 11.11734375 10.046875 10.77734375 C10.376875 12.75734375 10.706875 14.73734375 11.046875 16.77734375 C10.386875 16.77734375 9.726875 16.77734375 9.046875 16.77734375 C8.50417969 15.77832031 7.96148437 14.77929688 7.40234375 13.75 C6.68017487 12.44634448 5.95749181 11.1429737 5.234375 9.83984375 C4.69973633 8.85081055 4.69973633 8.85081055 4.15429688 7.84179688 C2.02012009 3.78693368 2.02012009 3.78693368 -1.953125 1.77734375 C0.53787966 8.10002666 3.9215169 13.50176311 7.63867188 19.16796875 C8.29512695 20.18890625 8.29512695 20.18890625 8.96484375 21.23046875 C9.36469482 21.84051758 9.7645459 22.45056641 10.17651367 23.07910156 C11.046875 24.77734375 11.046875 24.77734375 11.046875 27.77734375 C10.139375 27.46796875 9.231875 27.15859375 8.296875 26.83984375 C5.88124162 26.05011745 3.51907215 25.34785078 1.046875 24.77734375 C7.54232692 32.40243948 16.59060939 34.80928847 26.046875 36.77734375 C26.046875 37.43734375 26.046875 38.09734375 26.046875 38.77734375 C23.70219614 38.48425889 21.37961841 38.14825889 19.046875 37.77734375 C17.2525 37.49890625 17.2525 37.49890625 15.421875 37.21484375 C9.04912499 35.61535906 3.4865304 31.34297153 -1.953125 27.77734375 C-1.623125 26.12734375 -1.293125 24.47734375 -0.953125 22.77734375 C1.356875 22.77734375 3.666875 22.77734375 6.046875 22.77734375 C4.94310538 20.88127923 3.83884187 18.98550221 2.734375 17.08984375 C2.11949219 16.03410156 1.50460938 14.97835938 0.87109375 13.890625 C-0.27884861 11.92808953 -1.45641055 9.98123752 -2.671875 8.05859375 C-4.15362491 5.4203561 -4.20845685 3.75621538 -3.953125 0.77734375 C-1.953125 -0.22265625 -1.953125 -0.22265625 0 0 Z "
            fill="#DDDDDE"
            transform="translate(8.953125,11.22265625)"
          />
          <path
            d="M0 0 C2.9279494 1.46694422 4.03614954 3.64668209 5.73828125 6.40234375 C6.36347656 7.39105469 6.98867187 8.37976563 7.6328125 9.3984375 C8.05949219 10.24535156 8.48617188 11.09226562 8.92578125 11.96484375 C8.59578125 12.62484375 8.26578125 13.28484375 7.92578125 13.96484375 C6.81203125 13.90296875 5.69828125 13.84109375 4.55078125 13.77734375 C2.75640625 13.87015625 2.75640625 13.87015625 0.92578125 13.96484375 C-0.06421875 15.44984375 -0.06421875 15.44984375 -1.07421875 16.96484375 C-1.07421875 16.30484375 -1.07421875 15.64484375 -1.07421875 14.96484375 C-3.05421875 14.96484375 -5.03421875 14.96484375 -7.07421875 14.96484375 C-7.07421875 10.67484375 -7.07421875 6.38484375 -7.07421875 1.96484375 C-2.07421875 -0.03515625 -2.07421875 -0.03515625 0 0 Z "
            fill="#191C21"
            transform="translate(7.07421875,21.03515625)"
          />
          <path
            d="M0 0 C0.66 0 1.32 0 2 0 C2.33 0.66 2.66 1.32 3 2 C3.61875 1.67 4.2375 1.34 4.875 1 C9.75750698 -0.56240223 15.11728566 -1.1542229 19.98046875 0.79296875 C21.625 1.8125 21.625 1.8125 24 4 C24 4.99 24 5.98 24 7 C23.5153125 6.71125 23.030625 6.4225 22.53125 6.125 C17.36784787 3.26526959 13.88876144 2.50095242 8 3 C7.01 3.33 6.02 3.66 5 4 C5.33 4.99 5.66 5.98 6 7 C3.69 7 1.38 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z "
            fill="#DBDBDC"
            transform="translate(10,1)"
          />
          <path
            d="M0 0 C0.56847656 0.38671875 1.13695312 0.7734375 1.72265625 1.171875 C4.13651063 2.79991702 6.5660309 4.40221706 9 6 C10.093125 6.721875 11.18625 7.44375 12.3125 8.1875 C17.11993668 10.91019518 22.65001805 11.840398 28 13 C28 13.66 28 14.32 28 15 C25.65532114 14.70691514 23.33274341 14.37091514 21 14 C19.80375 13.814375 18.6075 13.62875 17.375 13.4375 C13.22902876 12.3641359 9.65689219 10.29606312 6 8.125 C5.41138184 7.78525146 4.82276367 7.44550293 4.21630859 7.09545898 C2.5625 6.0703125 2.5625 6.0703125 0 4 C0 2.68 0 1.36 0 0 Z "
            fill="#D4D4D5"
            transform="translate(7,35)"
          />
          <path
            d="M0 0 C1.7578125 0.13671875 1.7578125 0.13671875 4 1 C5.9921875 3.58203125 5.9921875 3.58203125 7.875 6.8125 C8.51179687 7.87082031 9.14859375 8.92914063 9.8046875 10.01953125 C11 13 11 13 10.1953125 15.38671875 C9.60363281 16.18529297 9.60363281 16.18529297 9 17 C6.55340482 14.10033164 4.32952019 11.10713904 2.25 7.9375 C1.82203125 7.28652344 1.3940625 6.63554687 0.953125 5.96484375 C0 4 0 4 0 0 Z "
            fill="#2A2C31"
            transform="translate(7,13)"
          />
          <path
            d="M0 0 C1.65 0 3.3 0 5 0 C5.66 2.97 6.32 5.94 7 9 C4.69 9.66 2.38 10.32 0 11 C0 7.37 0 3.74 0 0 Z "
            fill="#1E2026"
            transform="translate(0,12)"
          />
          <path
            d="M0 0 C3.96 0.33 7.92 0.66 12 1 C10 6 10 6 8 7 C8 7.99 8 8.98 8 10 C7.34 10 6.68 10 6 10 C3.78563385 6.78744808 1.946471 3.38516696 0 0 Z "
            fill="#2F3137"
            transform="translate(10,11)"
          />
          <path
            d="M0 0 C0.66 0 1.32 0 2 0 C2 0.99 2 1.98 2 3 C2.66 3 3.32 3 4 3 C4 3.66 4 4.32 4 5 C4.66 5 5.32 5 6 5 C6 5.66 6 6.32 6 7 C3.69 7 1.38 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z "
            fill="#D4D3D5"
            transform="translate(10,1)"
          />
          <path
            d="M0 0 C1.875 0.1875 1.875 0.1875 4 1 C5.25 3.5625 5.25 3.5625 6 6 C5.34 6 4.68 6 4 6 C3.67 6.99 3.34 7.98 3 9 C0.70620251 5.55930376 0 4.27709699 0 0 Z "
            fill="#3C3E44"
            transform="translate(7,13)"
          />
          <path
            d="M0 0 C1.65 0 3.3 0 5 0 C5.33 1.98 5.66 3.96 6 6 C3.03 5.505 3.03 5.505 0 5 C0 3.35 0 1.7 0 0 Z "
            fill="#34373C"
            transform="translate(0,12)"
          />
          <path
            d="M0 0 C5.28 0 10.56 0 16 0 C16 0.33 16 0.66 16 1 C15.24074219 1.13277344 14.48148438 1.26554688 13.69921875 1.40234375 C12.70535156 1.57894531 11.71148437 1.75554688 10.6875 1.9375 C9.70136719 2.11152344 8.71523438 2.28554688 7.69921875 2.46484375 C4.91810787 2.95746847 4.91810787 2.95746847 2 4 C2 3.01 2 2.02 2 1 C1.34 0.67 0.68 0.34 0 0 Z "
            fill="#37393F"
            transform="translate(10,0)"
          />
          <path
            d="M0 0 C0.79921875 0.20367187 1.5984375 0.40734375 2.421875 0.6171875 C3.02515625 0.78476562 3.6284375 0.95234375 4.25 1.125 C4.25 1.785 4.25 2.445 4.25 3.125 C-0.09464536 2.51674965 -4.42551867 1.86332608 -8.75 1.125 C-5.45750312 -0.91393155 -3.7130065 -0.98285466 0 0 Z "
            fill="#B6B6B7"
            transform="translate(30.75,46.875)"
          />
          <path
            d="M0 0 C3.3 0 6.6 0 10 0 C9.01 0.495 9.01 0.495 8 1 C8 2.32 8 3.64 8 5 C7.01 4.67 6.02 4.34 5 4 C5 3.34 5 2.68 5 2 C3.35 1.67 1.7 1.34 0 1 C0 0.67 0 0.34 0 0 Z "
            fill="#D0CFD1"
            transform="translate(24,20)"
          />
          <path
            d="M0 0 C1.9375 0.8125 1.9375 0.8125 4 2 C4.33 2.99 4.66 3.98 5 5 C3.68 5.33 2.36 5.66 1 6 C0.67 4.02 0.34 2.04 0 0 Z "
            fill="#222428"
            transform="translate(11,19)"
          />
        </svg>
      </button>
      <div className="absolute left-1/2 bottom-0 flex justify-center items-center space-x-2 pb-4">
        {activeAds?.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-white" : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

const HomePage = () => {
  const [terminalData, setTerminalData] = useState(null);
  const { terminalId } = useParams();
  const isShowDark = useIsNightTime(
    terminalData?.nighttimeStart,
    terminalData?.nighttimeEnd
  );
  useZoomDisable();
  useEffect(() => {
    fetcTerminalData(terminalId).then((res) => setTerminalData(res.data?.data));
  }, [terminalId]);

  if (isShowDark) return <div className="fixed inset-0 bg-black z-50"></div>;

  if (terminalData?.template === "C") {
    return <TemplateC advertisements={terminalData?.advertisements} />;
  }
  if (terminalData?.template === "A") {
    return <HomePageTempleteA />;
  }
  if (terminalData?.template === "B") {
    return <HomePageTempleteB />;
  }

  return <section className="text-gray-900 body-font relative"></section>;
};

export default HomePage;
